import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { IStoreSlice, Tld } from "@/redux/slices/store/types";

export const getTlds = createAsyncThunk(
  "store/getTlds",
  async () =>
    await axios({
      method: "GET",
      url: `/api/tlds/`,
    }).then((res) => res.data.result)
);

const pending = (state: IStoreSlice) => {
  state.tlds.tlds = { loaded: false, tlds: [] };
};

const fulfilled = (state: IStoreSlice, { payload }: { payload: Tld[] }) => {
  state.tlds.tlds = { loaded: true, tlds: payload };
};

export default {
  action: getTlds,
  pending,
  fulfilled,
};
